<template>
    <v-container style="padding-top: 80px">
        <v-row mb-2>
            <v-chip class="ma-2 chipSize" :color="this.colorReporte" style="align-self: center" large
                @click="detalleReporte()">
                <span class="txtRep"> Reporte: {{ this.RepInd }} </span>
            </v-chip>

            <v-chip :class="colorClass" class="chipSize" style="align-self: center" large>
                <span class="txtEtiq">
                    {{ this.etiqueta }}
                </span>
            </v-chip>
        </v-row>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-plus</v-icon>
                <p style="color: white;"> Agregar Movimientos</p>
            </v-card-title>
            <v-form ref="form" v-model="validForm" lazy-validation>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" style=" display: flex;">
                            <v-speed-dial v-model="speed" direction="bottom" :open-on-hover="false"
                                :transition="transition" style="align-self: center">
                                <template v-slot:activator>
                                    <v-btn v-model="speed" dark fab id="multimedia" color="primary">
                                        <v-icon class="btns" v-if="speed">mdi-close</v-icon>
                                        <v-icon class="btns" v-else>mdi-account-details</v-icon>
                                    </v-btn>
                                </template>

                                <v-tooltip right>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-badge bordered :color="coloricono" :icon="icon" overlap bottom offset-x="25"
                                            offset-y="20">
                                            <v-btn fab dark :color="color" v-bind="attrs" v-on="on"
                                                @click="Precierre()">
                                                <v-icon size="30" :color="'#FFFFFF'"> mdi-file-document </v-icon>
                                            </v-btn>
                                        </v-badge>
                                    </template>
                                    <span>Precierre</span>
                                </v-tooltip>

                                <v-tooltip right>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn fab dark color="#1E88E5" v-bind="attrs" v-on="on"
                                            @click="ControlCitas()">
                                            <v-icon size="30" :color="'#FFFFFF'"> mdi-calendar-month </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Control de Citas</span>
                                </v-tooltip>
                                <v-tooltip right>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn fab dark color="#1976D2" v-bind="attrs" v-on="on" @click="Indicios()">
                                            <v-icon size="30" :color="'#FFFFFF'">mdi-comment-account</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Indicios</span>
                                </v-tooltip>
                                <v-tooltip right>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn fab dark color="#1565C0" v-bind="attrs" v-on="on" @click="DatosPrueba()">
                                            <v-icon size="30" :color="'#FFFFFF'"> mdi-clipboard-list </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Datos Prueba</span>
                                </v-tooltip>
                                <v-tooltip right>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn fab dark color="#0D47A1" v-bind="attrs" v-on="on"
                                            @click="CriterioLider()">
                                            <v-icon size="30" :color="'#FFFFFF'"> mdi-account </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Criterio Lider</span>
                                </v-tooltip>
                            </v-speed-dial>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="12" md="6">
                            <div class="mt-2">
                                <span style="font-weight: bold;">Movimiento:</span>
                                <v-select outlined dense :items="movimientosArray" v-model="datos.movimientosSelected"
                                    item-text="label" item-value="value" placeholder="Seleccionar movimiento"
                                    :rules="ruleSelect">
                                </v-select>
                            </div>
                            <div class="mt-2"
                                v-if="datos.movimientosSelected != null && datos.movimientosSelected != ''">
                                <v-autocomplete outlined dense return-object :items="conceptoArray"
                                    v-model="datos.conceptoSelected" item-text="label" item-value="value"
                                    placeholder="Seleccione concepto" :rules="ruleSelect">

                                </v-autocomplete>
                            </div>


                            <div class="mt-2" v-if="validcancelacion">
                                <v-divider class="mt-1"></v-divider>
                                <span style="font-weight: bold;">Firma Electrónica Avanzada:</span>
                                <v-text-field solo
                                    v-on:blur="datos.firma = datos.firma != null ? datos.firma.trim() : null" dense
                                    hide-details style="-webkit-text-security: disc;" maxlength="17"
                                    v-model="datos.firma">
                                </v-text-field>
                                <div v-if="errorFirma">
                                    <span class='spanError' style="color:red;font-size:12px">{{ messageFirma }}</span>
                                    <br />
                                </div>
                            </div>

                            <div class="mt-2" v-if="validadisposicion">
                                <v-row style="padding:10px;">
                                    <span style="font-weight: bold;">Respuesta:</span>
                                    <v-radio-group :rules="rulesradios" v-model="datos.respuesta"
                                        style="margin: -1px; margin-left: 10px;" row>
                                        <v-radio label="SI" value="1"></v-radio>
                                        <v-radio label="NO" value="0"></v-radio>
                                    </v-radio-group>
                                </v-row>




                                <v-row v-if="datos.respuesta == '0'" style="padding:10px;">
                                    <span style="font-weight: bold;">El vehículo se encuentra en corralón:</span>
                                    <v-radio-group :rules="rulesradios" v-model="datos.tiporespuesta"
                                        style="margin: -1px; margin-left: 10px;" row>
                                        <v-radio label="SI" value="1"></v-radio>
                                        <v-radio label="NO" value="0"></v-radio>
                                    </v-radio-group>
                                </v-row>
                                <span style="color: red;">{{ ErrorPosConc }}</span>
                                <div class="mt-2">
                                    <span style="font-weight: bold;">Corralón:</span>
                                    <v-select outlined dense :items="corralonArray" v-model="datos.corralonSelected"
                                        item-text="label" item-value="value" no-data-text="Sin opciones"
                                        placeholder="Seleccione Corralón" :disabled="validavehdet">

                                    </v-select>
                                </div>

                                <div v-if="mostrarTiposCarga">
                                    <v-row style="padding:10px;">
                                        <span style="font-weight: bold;">Mercancia:</span>
                                        <v-radio-group :rules="rulesradios" v-model="datos.tieneMercancia"
                                            style="margin: -1px; margin-left: 10px;" row>
                                            <v-radio label="SI" :value="1"></v-radio>
                                            <v-radio label="NO" :value="2"></v-radio>
                                        </v-radio-group>
                                    </v-row>

                                    <div style="" v-if="datos.tieneMercancia === 1">
                                        <span style="font-weight: bold; ">Tipo de carga</span>
                                        <v-radio-group :rules="rulesradios" v-model="datos.tmclave">
                                            <v-radio v-for="(tipoMercancia) in tiposCarga"
                                                v-bind:key="tipoMercancia.sadas" :label="tipoMercancia.tmconcepto"
                                                :value="tipoMercancia.tmclave"></v-radio>
                                        </v-radio-group>
                                    </div>
                                </div>




                            </div>
                            <div class="mt-2">
                                <v-icon id="publico" class="disable-action" :color="'#4CAF50'" large v-show="tramPublic"
                                    @click="cambiarpubpriv()">mdi-lock-open</v-icon>
                                <v-icon id="privado" class="disable-action" :color="'#F44336'" large
                                    v-show="tramPrivate" @click="cambiarpubpriv()">mdi-lock</v-icon>
                            </div>
                            <div class="mt-2">

                                <span style="font-weight: bold;">Observaciones</span>
                                <v-textarea
                                    v-on:blur=" datos.observaciones != null ? datos.observaciones != '' ? datos.observaciones = datos.observaciones.trim() : null : null"
                                    class="mt-2 textarea" :class="obsClass" outlined hide-details
                                    v-model="datos.observaciones" :rules="rulestextarea"></v-textarea>
                                <span style="color: red;">{{ obsError }}</span>
                            </div>



                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                    <v-row justify="center">
                        <v-btn class="ma-2" color="#536DFE" style="color:white" :disabled="disabledSave"
                            @click="guardar()">Guardar</v-btn>
                        <v-btn class="ma-2" color="default" title="Limpiar" @click="limpiar()" :disabled="disabledSave">
                            Limpiar
                        </v-btn>
                        <v-btn class="ma-2" color="error" @click="cancelar()" :disabled="disabledSave">Cancelar</v-btn>
                    </v-row>
                </v-card-actions>
            </v-form>
        </v-card>
        <MovimientosLider ref="movimientosLider"></MovimientosLider>
    </v-container>
</template>
<script>
import Lideres from "@/services/Lideres/Lideres.service.js";
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';
import MovimientosLider from '@/components/pages/Lideres/MovimientosLider.vue';
import { mapState } from "vuex";


export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        MovimientosLider
    },
    data() {
        return {
            disabledSave: false,
            validForm: true,
            modal: false,
            rulesradios: [v => !!v || 'Seleccione una opción'],
            rulestextarea: [//v => !!v || 'Campo requerido',
                (v) => !!v || "Campo requerido",
                (v) => {
                    if (v == null) {
                        return true;
                    } else {
                        if (v.trim().length < 12) {
                            return "Mínimo 12 Carácteres";
                        } else if (v.trim().length > this.$store.state.maxLengthComentarios) {
                            return "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres";
                        } else return true;
                    }
                },
            ],
            movimientosArray: [],
            conceptoArray: [],
            corralonArray: [],
            datos: {
                movimientosSelected: null,
                conceptoSelected: null,
                firma: null,
                respuesta: null,
                tiporespuesta: null,
                corralonSelected: null,
                observaciones: null,
                nrreporte: 0,
                svindice: 0,
                aiclave: 0,
                esid: 0,
                fecha: null,
                tieneMercancia: null,
                tmclave: null
            },
            push: 0,
            ruleSelect: [(v) => !!v || "Campo requerido"],
            displayInputs: {
                nrreporte: 0,
                svindice: 0,
                aiclave: 0
            },
            obsError: "",
            ErrorPosConc: "",
            errorFirma: false,
            messageFirma: '',
            tramPublic: true,
            tramPrivate: true,
            obsClass: "",
            validcancelacion: false,
            validadisposicion: false,
            validavehdet: true,
            permisoLideres: false,
            speed: false,
            transition: "scale-transition",
            icon: null,
            coloricono: null,
            color: '#42A5F5',
            colorReporte: '',
            RepInd: '',
            colorClass: "",
            etiqueta: '',
            sending: false,
            asistenciaurl: '',
            ErrorTipoCarga: "",
            tiposCarga: [],
            mostrarTiposCarga: false
        }
    },
    computed: {
        ...mapState(['domain', 'informationPage']),
    },
    watch: {
        etiqueta(val) {
            if (val == "Abierto") {
                this.colorClass = "marginChip";
            } else if (val == "Concluido") {
                this.colorClass = "marginChipRed";
            } else if (val == "Cancelado") {
                this.colorClass = "marginChipPurple";
            } else if (val == "Conclusión Administrativa") {
                this.colorClass = "marginChipYellow";
            }
        },
        'datos.respuesta'(val) {
            this.datos.tiporespuesta = null;
            this.datos.corralonSelected = null;

            if (val == 0) {
                this.ErrorPosConc = "";
            }
            if (val == 0 || val == null) { //si es respuesta no entonces se bloquea corralón
                this.validavehdet = true;

            }
            else {
                this.ErrorPosConc = "";
                this.validaposibleconclusion(1);
                this.validavehdet = false;
            }

        },
        'datos.tiporespuesta'(val) {
            this.datos.corralonSelected = null;
            if (val == 0) {
                this.ErrorPosConc = "";
                this.validaposibleconclusion(3);
            }
            if ((val == 0 || val == null) && this.datos.respuesta == 0) { //si es respuesta no entonces se bloquea corralón
                this.validavehdet = true;
            }
            else {
                this.ErrorPosConc = "";
                this.validaposibleconclusion(2);
                this.validavehdet = false;
            }
        },
        'datos.firma'(val) {
            if (val == null || val == '') {
                this.errorFirma = true;
                this.messageFirma = 'Firma electrónica avanzada debe tener un mínimo de 8 y menor a 17 carácteres';
            }
            else {
                if (val.length < 8 || val.length > 16) {
                    this.errorFirma = true;
                    this.messageFirma = 'Firma electrónica avanzada debe tener un mínimo de 8 y menor a 17 carácteres';
                }
                else
                    this.errorFirma = false;
            }
        },
        'datos.observaciones'(val) {
            if (val != null) {
                if (val.length < 12) {
                    this.obsError = 'Mínimo 12 Carácteres';
                }
                else if (val.length > this.$store.state.maxLengthComentarios) {
                    this.obsError = "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres";
                }
                else
                    this.obsError = '';
            }
        },
        'datos.movimientosSelected'(val) {
            this.resetextrainfo();
            Lideres.obtenerTiposMovimiento(this, val);
        },
        async 'datos.conceptoSelected.value'(val) {

            this.resetextrainfo();
            if (val == 638) {
                this.validcancelacion = true;
            }
            else {
                this.validcancelacion = false;
            }
            if (val == 747) {
                Lideres.obtenerlistadoCorralonProv(this);
                await this.ConsultarTipoServicio();
                this.validadisposicion = true;
            }
            else {
                this.validadisposicion = false;
                this.datos.tieneMercancia = null
                this.datos.tmclave = null
            }

            if (val == 579) {
                let verificaLlamadas = await Lideres.verificaLlamadas(this);
                if (verificaLlamadas == 0) {
                    this.$swal({
                        position: 'center',
                        icon: 'warning',
                        title: 'Advertencia',
                        text: 'Para poder realizar el movimiento de calificación de reporte debe tener las 3 llamadas.',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        confirmButtonText: 'Aceptar',
                        confirmButtonColor: '#536DFE',
                        showCancelButton: false,
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            this.changeMov();
                        }
                    })
                }
            }
        },

        'datos.conceptoSelected.mppclave'(val) {
            if (val != null) {
                var privado = document.getElementById("privado");
                var publico = document.getElementById("publico");
                if (val == 2 || val == 4) {
                    if (val == 2) {
                        privado.classList.add("disable-action");
                        publico.classList.add("disable-action");
                    }
                    if (val == 4) {
                        privado.classList.remove("disable-action");
                        publico.classList.remove("disable-action");
                    }
                    this.tramPublic = false;
                    this.tramPrivate = true;

                    this.datos.esid = 8;
                    this.obsClass = "observaciones-privCon";
                }
                else if (val == 1 || val == 3 || val == 5) {
                    if (val == 1) {
                        privado.classList.add("disable-action");
                        publico.classList.add("disable-action");
                    }
                    if (val == 3 || val == 5) {
                        privado.classList.remove("disable-action");
                        publico.classList.remove("disable-action");
                    }

                    this.tramPublic = true;
                    this.tramPrivate = false;
                    this.datos.esid = 7;
                    this.obsClass = "observaciones-pubCon";

                }

            }
        },

        'datos.tieneMercancia'(val) {
            if (val === 2) this.datos.tmclave = null;
        },
        'datos.tipoCarga'(val) {
            if (val != 0) {

                this.datos.tmclave = null;
            }
        }

    },
    methods: {
        changeMov() {
            this.datos.conceptoSelected = this.conceptoArray[0];
        },
        async validaposibleconclusion(x) {  //1 respuesta 2 tiporespuesta
            let response = await Lideres.validaposibleconclusion(this);

            if (x == 1) {
                if (response == 1) {
                    this.datos.respuesta = null;
                    this.ErrorPosConc = "No puede detener el vehículo si la posible conclusión del reporte es No iniciado.";
                }
                else {
                    this.ErrorPosConc = "";
                }
            }
            if (x == 2) {
                if (response == 1) {
                    this.datos.tiporespuesta = null;
                    this.ErrorPosConc = "No puede detener el vehículo si la posible conclusión del reporte es No iniciado.";
                }
                else {
                    this.ErrorPosConc = "";
                }
            }
            if (x == 3) { //tiporespuesta en NO y es pendiente corralón
                if (response == 2) {
                    this.datos.tiporespuesta = null;
                    this.ErrorPosConc = "No puede liberar el vehículo si la posible conclusión del reporte es No iniciado pendiente corralón.";
                }
                else {
                    this.ErrorPosConc = "";
                }
            }


            //if (x == 4) {
            //    if (response == 1) {
            //        this.datos.respuesta = null;
            //        this.datos.tiporespuesta = null;
            //        setTimeout(() => {
            //            this.datos.corralonSelected = null;
            //            this.validavehdet = true;
            //            this.ErrorPosConc = "No puede detener el vehículo si la posible conclusión del reporte es No iniciado.";
            //        }, 400);

            //    }
            //    if (response == 2) {
            //        this.datos.respuesta = null;
            //        this.datos.tiporespuesta = null;
            //        setTimeout(() => {
            //            this.datos.corralonSelected = null;
            //            this.validavehdet = true;
            //            this.ErrorPosConc = "No puede liberar el vehículo si la posible conclusión del reporte es No iniciado pendiente corralón.";
            //        }, 400);

            //    }
            //}

        },
        resetextrainfo() {
            this.ErrorPosConc = "";
            this.datos.firma = null;
            this.datos.respuesta = null;
            this.datos.tiporespuesta = null;
            this.datos.corralonSelected = null;
        },
        async detalleReporte() {
            let reporte = {
                nrreporte: this.displayInputs.nrreporte,
                svindice: this.displayInputs.svindice,
                aiclave: this.displayInputs.aiclave,
                svfhconclusion: this.displayInputs.svfhconclusion
            };
            var ver = 0;
            let formData = new FormData();
            formData.append("nrreporte", this.displayInputs.nrreporte);
            formData.append("svindice", this.displayInputs.svindice);
            await SerBusqueda.ObtenerValidacion(this, formData).then(data => {
                ver = data;
            });
            if (ver == 0) {
                this.$router.push({ name: `${"DatosIncompletos"}` }).catch(error => error);
            }
            else {
                await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
                let url = this.$router.resolve({ name: `${"Asistencias"}` });
                window.open(url.href, '_blank');
            }
        },
        cambiarpubpriv() {
            if (this.datos.conceptoSelected.mppclave == 4) {
                this.datos.conceptoSelected.mppclave = 3;
            } else {
                this.datos.conceptoSelected.mppclave = 4;
            }
        },
        async guardar() {
            if (this.sending) { // Verifica si ya se está enviando
                return; // Si es así, no hace nada
            }
            this.sending = true; // Establece la variable de control en true
            this.disabledSave = true; // Desactiva el botón de guardar

            this.$refs.form.validate();
            let responseCancelado = await Lideres.validaReporteCancelado(this);
            if (responseCancelado == 1) {
                this.$swal({
                    position: 'center',
                    icon: 'warning',
                    title: 'Advertencia',
                    text: 'El reporte se encuentra cancelado.',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    confirmButtonText: 'Aceptar',
                    showCancelButton: false,
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        this.$router.push({ name: 'LideresMain' }).catch(error => error);
                    }
                })
                return
            }
            let valor = await this.validar();
            if (valor && this.$refs.form.validate()) {
                if (this.datos.conceptoSelected != null) {
                    if (this.datos.conceptoSelected.value == 747) { //movimiento de disposicion
                        if (this.datos.tieneMercancia === 2) this.datos.tmclave = 0;
                        if ((this.datos.respuesta == 1 || this.datos.tiporespuesta == 1) && this.datos.corralonSelected == null) {
                            this.$swal({
                                position: 'center',
                                icon: 'warning',
                                title: 'Advertencia',
                                text: 'No se ha seleccionado ningún corralón ¿Desea continuar?',
                                allowEscapeKey: false,
                                allowOutsideClick: false,
                                showCancelButton: true,
                                confirmButtonColor: '#536DFE',
                                cancelButtonColor: '#FF5C93',
                                confirmButtonText: 'Aceptar',
                                cancelButtonText: 'Cancelar',
                            }).then(async (result) => {
                                if (result.isConfirmed) {
                                    this.guardaMovimiento();
                                }
                            });
                        }
                        else {
                            this.guardaMovimiento();
                        }
                    }
                    else {
                        this.guardaMovimiento();
                    }
                }
            }
            // Al final del proceso, restablece las variables de control
            this.sending = false;
            this.disabledSave = false;
        },
        async guardaMovimiento() {
            this.$swal({
                title: 'Procesando solicitud',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: async () => {
                    this.disabledSave = true;
                    this.$swal.showLoading();
                    let res = await MetodosGenerales.obtenerFechaHoraBase();
                    this.datos.fecha = res.today; ///
                    this.datos.nrreporte = this.displayInputs.nrreporte;
                    this.datos.svindice = this.displayInputs.svindice;
                    let response = await Lideres.guardarMovtos(this);

                    if (response == 0) {
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Movimiento guardado exitosamente.',
                            showConfirmButton: true,
                            confirmButtonColor: '#536DFE',
                            confirmButtonText: 'Aceptar',
                            allowOutsideClick: false,
                            timer: 3000
                        }).then(() => {
                            this.$refs.movimientosLider.reloadTable();
                            this.ObtenerDatosIniciales();
                            this.limpiar();
                            this.disabledSave = false;

                            //location.reload()
                        });
                    } else if (response == 1) {
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Movimiento guardado exitosamente.',
                            showConfirmButton: true,
                            confirmButtonColor: '#536DFE',
                            confirmButtonText: 'Aceptar',
                            allowOutsideClick: false,
                            timer: 3000
                        }).then(() => {
                            this.$router.push({ name: `LideresMain` }).catch(error => error);
                        });
                    } else {
                        this.$swal({
                            position: 'center',
                            icon: 'error',
                            title: 'Error',
                            text: 'Ocurrió un error, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                            showConfirmButton: true,
                            confirmButtonColor: '#536DFE',
                            confirmButtonText: 'Aceptar',
                            allowOutsideClick: false,
                            timer: 3000
                        })
                        this.disabledSave = false;
                    }

                }
            })

        },
        async validar() {
            let valida = true;
            if (this.datos.observaciones == null || this.datos.observaciones == '') {
                this.obsError = 'Campo requerido';
                valida = false;
            }
            else {
                if (this.datos.observaciones.length < 12) {
                    this.obsError = 'Mínimo 12 Carácteres';
                    valida = false;
                }
                else if (this.datos.observaciones.length > this.$store.state.maxLengthComentarios) {
                    this.obsError = "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres";
                    valida = false;
                }
                this.datos.observaciones = this.datos.observaciones.toUpperCase();
            }
            if (this.datos.conceptoSelected != null) {
                if (this.datos.conceptoSelected.value == 638) {  //movimiento de cancelación
                    if (this.datos.firma == null || this.datos.firma == '') {
                        this.errorFirma = true;
                        this.messageFirma = 'Firma electrónica avanzada debe tener un mínimo de 8 y menor a 17 carácteres';
                        valida = false;
                    }
                    else {
                        if (this.datos.firma.length < 8 || this.datos.firma.length > 16) {
                            this.errorFirma = true;
                            this.messageFirma = 'Firma electrónica avanzada debe tener un mínimo de 8 y menor a 17 carácteres';
                            valida = false;
                        }
                        else {
                            let response = await Lideres.valFirmaElectronica(this.datos, this.datos.firma, 'CANCELACION POR EL LIDER');
                            if (response == 0) {
                                this.messageFirma = 'Firma electrónica incorrecta';
                                this.errorFirma = true;
                                valida = false;
                            }

                        }
                    }
                }
                if (this.datos.conceptoSelected.value == 747) { //movimiento de disposicion
                    if (this.datos.respuesta == 1) {
                        await this.validaposibleconclusion(1);  //si valido 0 limpia los campos y el valid es false
                    }
                    if (this.datos.tiporespuesta == 1) {
                        await this.validaposibleconclusion(2);  //si valido 0 limpia los campos y el valid es false
                    }
                    if (this.datos.tiporespuesta == 0) {
                        await this.validaposibleconclusion(3);  //si valido 0 limpia los campos y el valid es false
                    }
                }

            }
            return valida;
        },
        limpiar() {


            this.datos.movimientosSelected = null
            this.datos.conceptoSelected = null
            this.datos.firma = null
            this.datos.respuesta = null
            this.datos.tiporespuesta = null
            this.datos.corralonSelected = null
            this.datos.observaciones = null
            this.datos.tmclave = null
            this.datos.tieneMercancia = null

            this.ErrorPosConc = "";
            this.obsError = "";
            this.errorFirm = false;
            this.messageFirma = "";
            this.tramPublic = true;
            this.tramPrivate = true;
            this.obsClass = "";
            this.validcancelacion = false;
            this.validadisposicion = false;
            this.validavehdet = true;
            this.$refs.form.resetValidation();
        },
        cancelar() {
            this.$router.push({ name: `LideresMain` }).catch(error => error);
        },
        async ControlCitas() {
            let reporte = {
                nrreporte: this.displayInputs.nrreporte,
                svindice: this.displayInputs.svindice,
                aiclave: this.displayInputs.aiclave,
                svfhconclusion: this.displayInputs.svfhconclusion
            };
            var ver = 0;
            let formData = new FormData();
            formData.append("nrreporte", this.displayInputs.nrreporte);
            formData.append("svindice", this.displayInputs.svindice);
            ver = await SerBusqueda.ObtenerValidacion(this, formData);
            if (ver == 0) {
                this.$router.push({ name: `${"DatosIncompletos"}` }).catch(error => error);
            }
            else {
                let asistenciaurl = await MetodosGenerales.ObtenerURL(reporte);
                await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
                this.$router.push({ path: asistenciaurl + '/Reporte/Citas' });
            }
        },
        async CriterioLider() {
            this.$router.push({ name: `CriterioLider` }).catch(error => error);
        },
        async Indicios() {
            this.$router.push({ name: `Indicios` }).catch(error => error);
        },
        async DatosPrueba() {
            this.$router.push({ name: `DatosPrueba` }).catch(error => error);
        },
        async Precierre() {
            let response = await Lideres.ValidarPrecierre(this.datos);
            if (response.Mensaje == '' && response.Realizoprecierre == 0) {
                this.$router.push({ name: `Precierre` }).catch(error => error);
            } else if (response.Mensaje == '' && response.Realizoprecierre == 1) {
                this.$swal({
                    position: "center",
                    icon: "info",
                    title: "Información",
                    text: `Ya se realizó anteriormente el pre cierre.`,
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    confirmButtonColor: '#536DFE',
                    confirmButtonText: 'Aceptar',
                }).then(() => {
                });
            } else {
                this.$swal({
                    position: "center",
                    icon: "info",
                    title: "Información",
                    html: `${response.Mensaje}`,
                    confirmButtonColor: '#536DFE',
                    confirmButtonText: 'Aceptar',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    allowHtmlTags: true,
                }).then(() => {
                });
            }
        },
        async ObtenerDatosIniciales() {
            let datos = await MetodosGenerales.obtenerSessionReporte('valider');
            this.displayInputs = {
                nrreporte: datos.nrreporte,
                svindice: datos.svindice,
                aiclave: datos.aiclave,
                svfhconclusion: datos.svfhconclusion
            };
            Lideres.obtenerMovimientosValider(this);
            this.datos.nrreporte = datos.nrreporte;
            this.datos.svindice = datos.svindice;
            this.datos.aiclave = datos.aiclave;

            let encabezado = await Lideres.EncabezadoReporte(this.datos);
            this.RepInd = encabezado.nrreportei;
            this.colorReporte = encabezado.color;
            this.etiqueta = encabezado.etiqueta;

            let response = await Lideres.ValidarPrecierre(this.datos);
            this.icon = response.Mensaje == "" ? 'mdi-check-circle' : 'mdi-minus-circle';
            this.coloricono = response.Mensaje == "" ? 'green' : 'grey';
            this.color = response.Mensaje == "" && response.Realizoprecierre == 1 ? 'green' : '#42A5F5';
            this.asistenciaurl = await MetodosGenerales.ObtenerURL(this.datos);


        },
        async ConsultarTipoServicio() {
            await Lideres.ConsultarTipoServicio(this.datos.nrreporte, this.datos.svindice, this.datos.aiclave)
                .then((res) => this.mostrarTiposCarga = res.MostrarTiposCarga)
                .catch((e) => console.log(e))
            if (this.mostrarTiposCarga && !this.tiposCarga.length) this.tiposCarga = await Lideres.ObtenerTiposCarga()

        }
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '40').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 40)//Permiso para ver lideres
                        this.permisoLideres = true;
                });
            }
            if (this.permisoLideres == false) {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        });
    },
    async mounted() {
        //document.removeEventListener('visibilitychange', this.visibilitychange);
        await this.ObtenerDatosIniciales();
    }
}
</script>

<style>
.textarea {
    resize: none !important;
}

.observaciones-privCon {
    background-image: url("https://www.ausa.com.mx/img/Prusia/privado.png");
    background-repeat: repeat;
}

.observaciones-pubCon {
    background-image: url("https://www.ausa.com.mx/img/Prusia/publico.png");
    background-repeat: repeat;
}
</style>